import { base } from "./base";
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { GetRadarQuery } from "../../../generated/graphql";

export const dataConfigTransform = (query: GetRadarQuery) => {

    const data = query.pages?.items[0];
    
    if (data) {
        const config = {
            ...base,
            title: data.title,
            quadrants: {
                quadrant1: data.quadrant1?.name && data.quadrant1?.name.length ? data.quadrant1?.name : '',
                quadrant2: data.quadrant2?.name && data.quadrant2?.name.length ? data.quadrant2?.name : '',
                quadrant3: data.quadrant3?.name && data.quadrant3?.name.length ? data.quadrant3?.name : '',
                quadrant4: data.quadrant4?.name && data.quadrant4?.name.length ? data.quadrant4?.name : '',
            },
            quadrantsMap: {
                quadrant1: {
                    ...base.quadrantsMap.quadrant1,
                    description: documentToHtmlString(data.quadrant1?.description?.json),
                },
                quadrant2: {
                    ...base.quadrantsMap.quadrant2,
                    description: documentToHtmlString(data.quadrant2?.description?.json),
                },
                quadrant3: {
                    ...base.quadrantsMap.quadrant3,
                    description: documentToHtmlString(data.quadrant3?.description?.json),
                },
                quadrant4: {
                    ...base.quadrantsMap.quadrant4,
                    description: documentToHtmlString(data.quadrant4?.description?.json),
                }
            }
        };
        return config;
    }
}

